window.$ = window.jQuery = require('jquery');

import * as THREE from 'three';
import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger'
import {ScrollToPlugin} from 'gsap/ScrollToPlugin'
import lottie from 'lottie-web';

const surr1 = 'ridea/npm/js/frontend/pages/json/surr1.json';
const surr2 = 'ridea/npm/js/frontend/pages/json/surr2.json';

let mm = gsap.matchMedia();

mm.add("(min-width: 769px)", () => {
    // --- 這部分只在桌機版執行 ---
    const container = document.querySelector(".cards-container");
    const cards = gsap.utils.toArray(".card");
    const cardWidth = 600;
    const gap = 40;
    const totalScrollDistance = (cardWidth + gap) * (cards.length - 1);

    gsap.to(container, {
        x: -totalScrollDistance,
        ease: "none",
        scrollTrigger: {
            trigger: ".scroll-wrapper",
            pin: true,
            scrub: 1,
            start: "top top",
            end: () => "+=" + totalScrollDistance,
        }
    });
});

mm.add("(max-width: 768px)", () => {
    // --- 手機板：不需要寫任何 GSAP，ScrollTrigger 會自動失效 ---
    // 您可以在這裡針對手機板做其他輕微的調整（選填）
});
// --- 初始化全域變數 ---
var renderer = new THREE.WebGLRenderer({ antialias: true });
// 關鍵：這行確保色彩不會灰髒
renderer.outputColorSpace = THREE.SRGBColorSpace;

var camera = new THREE.PerspectiveCamera(20, window.innerWidth / window.innerHeight, 1, 500);
camera.position.set(0, 10, 22);

var scene = new THREE.Scene();
var city = new THREE.Object3D();
var smoke = new THREE.Object3D();
var town = new THREE.Object3D();

var createCarPos = true;
var mouse = new THREE.Vector2();
var autoRotationTimer = 0;

// --- 背景與霧氣 (完全依照你的設定) ---
var setcolor = 0xffffff;
scene.background = new THREE.Color(setcolor);
scene.fog = new THREE.Fog(setcolor, 12, 25);

// --- 輔助函數 ---
function mathRandom(num = 8) {
    return -Math.random() * num + Math.random() * num;
}

function setTintColor() {
    // 增加更明顯的深淺色階對比
    var colors = [
        0xFFFFFF, // 極亮白
        0xEEEEEE, // 亮灰
        0xCCCCCC, // 中灰
        0x999999  // 深灰（增加側面的深度感）
    ];
    return colors[Math.floor(Math.random() * colors.length)];
}

// --- 初始化城市 ---
function init() {
    // 獲取容器
    const container = document.getElementById('sur-bg-city') || document.body;
    renderer.setSize(container.clientWidth || window.innerWidth, container.clientHeight || window.innerHeight);
    container.appendChild(renderer.domElement);

    if (window.innerWidth > 800) {
        renderer.shadowMap.enabled = true;
        renderer.shadowMap.type = THREE.PCFSoftShadowMap;
    }

    var segments = 2;
    for (var i = 1; i < 100; i++) {
        var geometry = new THREE.BoxGeometry(1, 1, 1, segments, segments, segments);
        var material = new THREE.MeshStandardMaterial({
            color: setTintColor(),
            roughness: 0.5,
            metalness: 0.1,
            flatShading: true, // <--- 加入這行！

            side: THREE.DoubleSide
        });

        var cube = new THREE.Mesh(geometry, material);
        var floor = new THREE.Mesh(geometry, material);

        cube.castShadow = true;
        cube.receiveShadow = true;

        var targetHeight = 0.1 + Math.abs(mathRandom(4));
        var cubeWidth = 0.9 + mathRandom(0.1);

        cube.scale.set(cubeWidth, 0.001, cubeWidth);
        cube.position.x = Math.round(mathRandom(8));
        cube.position.z = Math.round(mathRandom(8));
        cube.position.y = 0;

        // --- 關鍵修正：將 TweenMax 改為 GSAP 3 ---
        gsap.to(cube.scale, {
            y: targetHeight,
            duration: 2, // 舊版 TweenMax 是放在第二個參數，新版放在這裡
            delay: i * 0.03,
            ease: "expo.out",
            onUpdate: function() {
                cube.position.y = cube.scale.y / 2;
            }
        });

        floor.scale.set(cubeWidth, 0.05, cubeWidth);
        floor.position.set(cube.position.x, -0.025, cube.position.z);

        town.add(floor);
        town.add(cube);
    }

    // 紅色粒子
    var gmaterial = new THREE.MeshBasicMaterial({color: 0xAD121D, side: THREE.DoubleSide});
    var gparticular = new THREE.CircleGeometry(0.02, 3);
    for (var h = 1; h < 300; h++) {
        var particular = new THREE.Mesh(gparticular, gmaterial);
        particular.position.set(mathRandom(5), mathRandom(5), mathRandom(5));
        particular.rotation.set(mathRandom(), mathRandom(), mathRandom());
        smoke.add(particular);
    }

    // 地面
    var pmaterial = new THREE.MeshPhongMaterial({ color: 0xFFFFFF, side: THREE.DoubleSide, transparent: true, opacity: 0.9 });
    var pgeometry = new THREE.PlaneGeometry(60, 60);
    var pelement = new THREE.Mesh(pgeometry, pmaterial);
    pelement.rotation.x = -90 * Math.PI / 180;
    pelement.position.y = -0.05;
    pelement.receiveShadow = true;
    city.add(pelement);
}

// --- 移動線條 ---
var createCars = function(cScale = 2, cPos = 20, cColor = 0xAD121D) {
    var cMat = new THREE.MeshBasicMaterial({color: cColor});
    var cGeo = new THREE.BoxGeometry(1, cScale/40, cScale/40);
    var cElem = new THREE.Mesh(cGeo, cMat);
    var cAmp = 3;

    if (createCarPos) {
        createCarPos = false;
        cElem.position.x = -cPos;
        cElem.position.z = mathRandom(cAmp);
        gsap.to(cElem.position, { x: cPos, duration: 10, repeat: -1, yoyo: true, delay: mathRandom(3) });
    } else {
        createCarPos = true;
        cElem.position.x = mathRandom(cAmp);
        cElem.position.z = -cPos;
        cElem.rotation.y = 90 * Math.PI / 180;
        gsap.to(cElem.position, { z: cPos, duration: 12, repeat: -1, yoyo: true, delay: mathRandom(3), ease: "power1.inOut" });
    }
    cElem.position.y = Math.abs(mathRandom(5));
    city.add(cElem);
};

// --- 光源 ---
// 1. 大幅降低環境光（它是層次感的殺手）
// 數值從 2.5 降到 0.3~0.5。它只負責提供基礎可見度，不應該是主光源。
var ambientLight = new THREE.AmbientLight(0xFFFFFF, 0.4);

// 2. 增加一個強烈的「半球光」(HemisphereLight)
// 這能模擬天光的層次：頂部亮白，底部深灰，立刻產生垂直方向的渲染感。
var hemiLight = new THREE.HemisphereLight(0xffffff, 0x444444, 1.0);
hemiLight.position.set(0, 20, 0);
scene.add(hemiLight);

// 3. 修改主燈為平行光 (DirectionalLight)，並從側面照射
// 平行光在計算建築物明暗邊界時比 SpotLight 更乾淨。
var lightFront = new THREE.DirectionalLight(0xFFFFFF, 1.2);
lightFront.position.set(10, 20, 5); // 重點：X 或 Z 軸要有數值，光才會從斜側面打過來
lightFront.castShadow = true;

// 設置陰影範圍 (DirectionalLight 需要設定範圍才能看到影子)
lightFront.shadow.camera.left = -20;
lightFront.shadow.camera.right = 20;
lightFront.shadow.camera.top = 20;
lightFront.shadow.camera.bottom = -20;
lightFront.shadow.mapSize.width = 2048;
lightFront.shadow.mapSize.height = 2048;

scene.add(ambientLight);
scene.add(lightFront);
city.add(lightFront);
scene.add(city);
city.add(smoke);
city.add(town);

// --- 動畫迴圈 ---
var animate = function() {
    requestAnimationFrame(animate);
    autoRotationTimer += 0.002;

    var targetRotationY = autoRotationTimer + (mouse.x * 0.5);
    var targetRotationX = -mouse.y * 0.3;

    city.rotation.y += (targetRotationY - city.rotation.y) * 0.05;
    city.rotation.x += (targetRotationX - city.rotation.x) * 0.05;

    if (city.rotation.x < -0.05) city.rotation.x = -0.05;
    if (city.rotation.x > 0.8) city.rotation.x = 0.8;

    smoke.rotation.y += 0.002;
    camera.lookAt(city.position);
    renderer.render(scene, camera);
}

// --- 事件與啟動 ---
document.addEventListener('DOMContentLoaded', () => {
    getReCaptchaPrice();
    observeFormAjax('#price-contact-form','#price_contact_submit_button', {
        ignore : [] ,
        rules: {
            name: { required: true },
            sex: { required: true },
            email: { required: true, email: true },
            tel: { required: true },
            content: { required: true },
            company: { required: true},
            budget: { required: true },
            "contact_projects[]": "required",
        },
        messages: {
            company: "請輸入公司名稱",
            name: "請輸入姓名",
            email: {
                required: '請輸入電子郵件',
                email: '請輸入正確 Email 格式',
            },
            tel: "請輸入聯絡電話",
            budget: "請輸入專案預算",
            content: "請輸入諮詢內容",
            "contact_projects[]": "請選擇專案類型",
        }
    }, null, 'price-contact-form');

    $('.rd_clear').on('click', function(){
        var form = document.getElementById("price-contact-form");
        form.reset();

        $('.rd_price_sex').removeClass('now');
        $('.rd_price_sex[data-sex="M"]').addClass('now');
        $('[name="sex"]').val('M');

        $('.rd-price-contact-project').removeClass('now');
        $('.rd-price-mutliple-contact-projects').not('#main_price_contact_project_input').remove();
        $('#main_price_contact_project_input').val('');
        $('#rd-price-contact-project-area .rd_notice').remove();
    });

    $('.rd_price_sex').on('click', function () {
        $('.rd_price_sex').removeClass('now');
        $(this).addClass('now');
        $('[name="sex"]').val($(this).attr('data-sex'));
    });

    $('.rd-price-contact-project').on('click', function(){
        if($(this).hasClass('now')){
            $('#input_price_contact_project_' + $(this).data('id')).remove();
            $(this).removeClass('now');
        }else{
            $('#rd-price-contact-project-area').append('<input type="hidden" class="rd-price-mutliple-contact-projects rd-price-contact-project-selected" name="contact_projects[]" id="input_price_contact_project_'+ $(this).data('id') +'" value="'+ $(this).data('id') +'">');
            $(this).addClass('now');
        }

        if ($('.rd-price-mutliple-contact-projects')[1]){
            $('#main_price_contact_project_input').val('pass');
        } else {
            $('#main_price_contact_project_input').val('');
        }

        var allEmpty = true;

        $('.rd-price-contact-project-selected').each(function(){
            if ($(this).val().trim() !== '') {
                allEmpty = false;
                return false;
            }
        });

        let target  = $(this).closest('.rd_show_validator_error');

        if (allEmpty) {
            if ($(target).find('.rd_notice').length === 0) {
                $(target).append('<div class="rd_notice" style="width: 100%;margin-top: .25rem;font-size: 80%;color: #dc3545;">請選擇專案類型</div>');
            }
            $(this).closest('.rd_required').find('.selectric').css('border-bottom', '1px solid #dc3545');
        } else {
            $(this).closest('.rd_required').find('.rd_notice').remove();
            $(this).closest('.rd_required').find('.selectric').css('border-bottom', '1px solid #ddd');
        }
    });

    init();
    for (var i = 0; i < 25; i++) { createCars(0.1, 20); }
    animate();

    window.addEventListener('mousemove', (e) => {
        mouse.x = (e.clientX / window.innerWidth) * 2 - 1;
        mouse.y = -(e.clientY / window.innerHeight) * 2 + 1;
    });

    window.addEventListener('resize', () => {
        const container = document.getElementById('sur-bg-city') || document.body;
        camera.aspect = container.clientWidth / container.clientHeight;
        camera.updateProjectionMatrix();
        renderer.setSize(container.clientWidth, container.clientHeight);
    });

    const asurr1 = lottie.loadAnimation({
        container: document.getElementById('surr1'), // **DOM 容器**
        renderer: 'svg', // 渲染模式：'svg' (推薦) 或 'canvas'
        loop: true, // 是否循環播放
        autoplay: true, // 是否自動播放
        path: surr1 // **JSON 檔案路徑**
    });

    const asurr2 = lottie.loadAnimation({
        container: document.getElementById('surr2'), // **DOM 容器**
        renderer: 'svg', // 渲染模式：'svg' (推薦) 或 'canvas'
        loop: true, // 是否循環播放
        autoplay: true, // 是否自動播放
        path: surr2 // **JSON 檔案路徑**
    });

    $('.qustion-box').on('click', function() {
        // 1. 取得當前的 li
        var $parentLi = $(this).closest('li');

        // 2. 切換外層 li 的 .now class
        $parentLi.toggleClass('now');

        // 3. 讓同一個 li 裡的 .answer-box 進行滑動切換
        $parentLi.find('.answer-box').slideToggle();

        // --- 選配功能：若希望一次只打開一個，其他的自動收起，可加入以下程式碼 ---

        $parentLi.siblings().removeClass('now').find('.answer-box').slideUp();

    });
});

let surround1 = gsap.timeline();
ScrollTrigger.create({
    animation: surround1,
    trigger: ".surround-s1-kv",
    start: "100 top",
    end: "500 top",
    scrub: 2,
    // markers:true
});
surround1.fromTo(".cirred", {top:'0'},{top:'90%'}, 0)

mm.add({
    // 同時定義多個斷點
    isDesktop: "(min-width: 769px)",
    isMobile: "(max-width: 768px)"
}, (context) => {
    // 根據斷點動態取得 start 的位置
    let { isDesktop } = context.conditions;

    let surround2 = gsap.timeline();

    ScrollTrigger.create({
        animation: surround2,
        trigger: ".surround-s3-camera",
        // 如果是電腦版用 top，手機版用 bottom
        start: isDesktop ? "top-=100 top" : "bottom-=700 top",
        end: isDesktop ? "top+=100 top" : "bottom-=500 top",
        scrub: 2,
        // markers:true
    });

    surround2.fromTo(".camera1", {opacity: 1}, {opacity: 0}, 0);
    surround2.fromTo(".camera2", {opacity: 0}, {opacity: 1}, 0);

    return () => {
        // 選用：如果需要清理非 GSAP 的事件監聽可以在這寫
    };
});

let s2scroline = gsap.timeline();
ScrollTrigger.create({
    animation: s2scroline,
    trigger: ".surround-s3-camera",
    start: "top-=300 top",
    end: "top+=0 top",
    scrub: 2,
    // markers:true
});
s2scroline.fromTo(".surround-s2-why .linered", {y:0},{y:70}, 0)

let s3scroline = gsap.timeline();
ScrollTrigger.create({
    animation: s3scroline,
    trigger: ".surround-s4-progress",
    start: "top-=400 top",
    end: "top+=0 top",
    scrub: 2,
    // markers:true
});
s3scroline.fromTo(".surround-s4-progress .linered", {y:0},{y:70}, 0)

let s4scroline = gsap.timeline();
ScrollTrigger.create({
    animation: s4scroline,
    trigger: ".surround-s5-demo",
    start: "top-=400 top",
    end: "top+=0 top",
    scrub: 2,
    // markers:true
});
s4scroline.fromTo(".surround-s5-demo .linered", {y:0},{y:70}, 0)

let s5scroline = gsap.timeline();
ScrollTrigger.create({
    animation: s5scroline,
    trigger: ".surround-s6-qa",
    start: "top-=400 top",
    end: "top+=0 top",
    scrub: 2,
    // markers:true
});
s5scroline.fromTo(".surround-s6-qa .linered", {y:0},{y:70}, 0)

let s6scroline = gsap.timeline();
ScrollTrigger.create({
    animation: s6scroline,
    trigger: ".surround-form",
    start: "top-=400 top",
    end: "top+=0 top",
    scrub: 2,
    // markers:true
});
s6scroline.fromTo(".surround-form .linered", {y:0},{y:70}, 0)

ScrollTrigger.create({
    trigger: ".surround-s2-why",
    start: "top-=500 top",
    // markers:true,
    onEnter:function () {
        $('.surround-s2-why').addClass('vivi')
    }
});
ScrollTrigger.create({
    trigger: ".surround-s3-camera",
    start: "top-=500 top",
    // markers:true,
    onEnter:function () {
        $('.surround-s3-camera').addClass('vivi')
    }
});
ScrollTrigger.create({
    trigger: ".surround-s4-progress",
    start: "top-=500 top",
    // markers:true,
    onEnter:function () {
        $('.surround-s4-progress').addClass('vivi')
    }
});
ScrollTrigger.create({
    trigger: ".surround-s5-demo",
    start: "top-=500 top",
    // markers:true,
    onEnter:function () {
        $('.surround-s5-demo').addClass('vivi')
    }
});
ScrollTrigger.create({
    trigger: ".surround-s5-demo",
    start: "top-=500 top",
    // markers:true,
    onEnter:function () {
        $('.surround-s5-demo').addClass('vivi')
    }
});
ScrollTrigger.create({
    trigger: ".surround-s6-qa",
    start: "top-=500 top",
    // markers:true,
    onEnter:function () {
        $('.surround-s6-qa').addClass('vivi')
    }
});
ScrollTrigger.create({
    trigger: ".surround-form",
    start: "top-=500 top",
    // markers:true,
    onEnter:function () {
        $('.surround-form').addClass('vivi')
    }
});
document.querySelector('#to-demo').addEventListener('click', function(e) {
    e.preventDefault();
    const target = document.querySelector('.surround-s5-demo');

    target.scrollIntoView({
        behavior: 'smooth' // 平滑滾動
    });
});
